module.exports = __webpack_public_path__ + "static/q14_o-757e927c4962fef041555901c89b6c8c.png";